
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskStatusDialog extends SiteEntityDialog<TaskStatusRow, any> {
        protected getFormKey() { return TaskStatusForm.formKey; }
        protected getIdProperty() { return TaskStatusRow.idProperty; }
        protected getLocalTextPrefix() { return TaskStatusRow.localTextPrefix; }
        protected getNameProperty() { return TaskStatusRow.nameProperty; }
        protected getService() { return TaskStatusService.baseUrl; }

        protected form = new TaskStatusForm(this.idPrefix);

    }
}